// extracted by mini-css-extract-plugin
export var locationCard = "_hy-0";